//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Nav from "@/components/Nav";
import Dlist from "@/components/Dlist";

export default {
  name: "Overseas",
  components: { Nav, Dlist },
  data() {
    return {
      overslist: [], //数据数组
      city_id: 3, //文章分类：1寄宿家庭/后期服务/在线课程，2联系我们，3留学资讯，4活动管理
      total: 0, //记录数6
      page: 1, //页数
      limit: 4, //条数
      showlog: false,
      isLoading:false,//是否正在加载数据
    };
  },
  methods: {
    //获取数据
    getData() {
      this.$api
        .gethotdata({
          params: {
            limit: this.limit,
            category_id: this.city_id,
            page: this.page
          }
        })
        .then(res => {
          var data = res.data.data;
          if (res.data.success && res.data.code == 0) {
            this.overslist = this.overslist.concat(data.items);
            this.total = data.total;
            this.showlog = false;
            this.isLoading = false
          }else{
            this.$vux.toast.text(res.data.message, "middle");
          }
        });
    }, 
    //监听滚动条下拉
    scrool() {
      let that = this;
      var scrollTop = this.$refs.rightContent.scrollTop;
      var clientHeight = this.$refs.rightContent.clientHeight;
      var scrollHeight = this.$refs.rightContent.scrollHeight;

      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (that.limit * that.page < that.total && !that.isLoading) { 
          that.page++;
          that.showlog = true;
          that.isLoading = true
          setTimeout(function() {
            that.getData();
          }, 1500);
        }
      }
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$refs.rightContent.addEventListener("scroll", this.scrool);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Overseas/overseas.vue